import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { CenterFrameLayout } from 'Layouts';
import { ShippingForm } from 'Forms/ShippingForm';
import { FinePrint } from 'Components/Texts';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { Navigate, useNavigate } from 'react-router-dom';
import { updateShippingAddress } from 'State/Checkout/CheckoutActions';

import './ShippingContainer.css';

export const ShippingComponent = ({ routes, history, isPlanSelected, hasSubscription, updateShippingAddress }) => {
  const navigate = useNavigate();
  const onShippingFormSubmit = (address) => {
    updateShippingAddress(address);
    navigate(routes.payment);
  };

  useEffect(() => {
    trackEvent(TRACKING_ENUMS.EVENT_SHIPPING_FORM_STARTED);
    return function shippingCompleted() {
      trackEvent(TRACKING_ENUMS.EVENT_SHIPPING_FORM_COMPLETED);
    };
  }, []);

  if (!isPlanSelected) {
    if (hasSubscription) {
      return <Navigate replace to={routes.changePlans} />;
    }
    return <Navigate replace to={routes.signupPlans} />;
  }

  return (
    <CenterFrameLayout title="Enter your shipping address" customClass="shippingContainer">
      <div className="roundContentContainer">
        <ShippingForm onFormSubmit={onShippingFormSubmit} />
        <FinePrint
          className="shippingContainerFinePrint"
          text="Fox Nation Merchandise fulfillment begins upon trial period conclusion."
        />
      </div>
    </CenterFrameLayout>
  );
};

const mapStateToProps = ({ appConfig: { routes }, subscription: { hasSubscription }, plans: { isPlanSelected } }) => ({
  routes,
  isPlanSelected,
  hasSubscription,
});
const mapDispatchToProps = { updateShippingAddress };
export const ShippingContainer = connect(mapStateToProps, mapDispatchToProps)(ShippingComponent);
